/**
 * @flow
 * @relayHash 672201e8e4d940956c41bdf7e13a1ecb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiMessageRole = "ASSISTANT" | "SYSTEM" | "USER";
export type AiChatMessagesQueryVariables = {|
  conversationId: string
|};
export type AiChatMessagesQueryResponse = {|
  +aiMessages: $ReadOnlyArray<{|
    +messageId: string,
    +role: AiMessageRole,
    +content: ?string,
    +tokensUsed: ?number,
    +createdAt: ?any,
  |}>
|};
export type AiChatMessagesQuery = {|
  variables: AiChatMessagesQueryVariables,
  response: AiChatMessagesQueryResponse,
|};
*/


/*
query AiChatMessagesQuery(
  $conversationId: ID!
) {
  aiMessages(conversationId: $conversationId) {
    messageId
    role
    content
    tokensUsed
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "conversationId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "aiMessages",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "concreteType": "AiMessage",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "messageId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "content",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "tokensUsed",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AiChatMessagesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AiChatMessagesQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AiChatMessagesQuery",
    "id": null,
    "text": "query AiChatMessagesQuery(\n  $conversationId: ID!\n) {\n  aiMessages(conversationId: $conversationId) {\n    messageId\n    role\n    content\n    tokensUsed\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '36848c1ac7a120137823b75518ade310';
module.exports = node;
